
  var _styles = {
  "city-selection-margin": {
    "paddingTop": "2.66667rem",
    "paddingRight": 0,
    "paddingBottom": "2.66667rem",
    "paddingLeft": 0
  },
  "city-selection-divider": {
    "height": "1px",
    "backgroundColor": "rgb(244,245,248)"
  },
  "city-selection-short-divider": {
    "height": "1px",
    "width": "9.46667rem",
    "backgroundColor": "rgb(244,245,248)"
  },
  "city-selection-city-name-list": {
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "wrap",
    "marginTop": "0.21333rem",
    "marginRight": "0.32rem",
    "marginBottom": "0.4rem",
    "marginLeft": "0.45333rem"
  },
  "city-selection-city-name-container": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "2.13333rem",
    "height": "0.8rem",
    "background": "#f4f5f8",
    "borderRadius": "0.10667rem",
    "marginRight": "0.16rem",
    "marginBottom": "0.24rem"
  },
  "city-selection-city-name": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.37333rem",
    "color": "rgb(32,32,32)",
    "letterSpacing": 0,
    "lineHeight": "0.37333rem"
  },
  "city-selection-little-gray-text-margin": {
    "marginTop": "0.42667rem"
  },
  "city-selection-little-gray-text": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(89,89,89)",
    "letterSpacing": 0,
    "lineHeight": "0.32rem",
    "marginLeft": "0.42667rem"
  },
  "city-selection-scroll-view-main": {
    "width": "10rem"
  }
};



  module.exports = _styles;
  